import { nodeAuthApi } from '~c/services';

/**
 * Hook to check if Okta authentication is enabled.
 * Fetches configuration from the backend via RTK Query (auto-deduplicates requests).
 */
export function useOktaAuth() {
  const { data } = nodeAuthApi.useOktaConfigQuery();

  return {
    isEnabled: !!(data?.clientId && data?.domain),
    config: data,
  };
}

export default useOktaAuth;
